export default function Overlay() {
	return <section id="overlay">
		<h1>Gamestate Overlay</h1>
		<p>We've partnered with <a href="//overman.dev" target="_blank" rel="noreferrer">OVERMAN</a> to bring custom gamestate integration and stream overlays!

		Replace or enhance the default game overlay with one that displays more information, is aesthetically pleasing, unique, and attracts viewers.

		Custom color schemes and styles are made to match the theme of the event.</p>
	</section>
}
